import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { ThemeConstantService } from '../../shared/services/theme-constant.service';
import {ProductRoutingModule} from './product-routing.module';
import { FundListComponent } from 'src/app/modules/product/components/fund-list/fund-list.component';
import { BondIssuerListComponent } from 'src/app/modules/product/components/bond-issuer-list/bond-issuer-list.component';
import { CertificateListComponent } from 'src/app/modules/product/components/certificate-list/certificate-list.component';
import { BondListComponent } from 'src/app/modules/product/components/bond-list/bond-list.component';
import { EditFundComponent } from 'src/app/modules/product/components/edit-fund/edit-fund.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FeeTransferComponent } from 'src/app/modules/product/components/fee-transfer/fee-transfer.component';
import { UpdateNavPopupComponent } from './components/update-nav-popup/update-nav-popup.component';
import { FileUploadModule } from 'ng2-file-upload';
import { LocaleService } from './services/datepicker.service';
import { EditFeeComponent } from './components/edit-fee/edit-fee.component';
import { CheckChangeProductPopupComponent } from './components/check-change-product-popup/check-change-product-popup.component';
import { EditDividendComponent } from './components/edit-dividend/edit-dividend.component';
import { DividendListComponent } from './components/dividend-list/dividend-list.component';
import { SipListComponent } from './components/sip-list/sip-list.component';
import { ProductsListComponent } from './pages/products-list/products-list.component';
import { EditSipComponent } from './components/edit-sip/edit-sip.component';
import { GoldListComponent } from './components/gold-list/gold-list.component';
import { EditGoldComponent } from './components/edit-gold/edit-gold.component';
import { NAVListComponent } from './components/nav-list/nav-list.component';
import { TabsEditFundComponent } from './components/tabs-edit-fund/tabs-edit-fund.component';
import { UploadDocumentFundPopupComponent } from './components/upload-document-fund-popup/upload-document-fund-popup.component';
import { DocumentFilesForFundComponent } from './components/document-files-for-fund/document-files-for-fund.component';
import { SetUpNewFeeFundComponent } from './components/set-up-new-fee-fund/set-up-new-fee-fund.component';
import { NewBuyFeeFundComponent } from './components/new-buy-fee-fund/new-buy-fee-fund.component';
import { NewSellFeeFundComponent } from './components/new-sell-fee-fund/new-sell-fee-fund.component';
import { NewTransferFeeFundComponent } from './components/new-transfer-fee-fund/new-transfer-fee-fund.component';
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }
@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ProductRoutingModule,
        FileUploadModule,
        TranslateModule.forRoot({
            loader: {
            provide: TranslateLoader,
            useFactory: createTranslateLoader,
            deps: [HttpClient]
            }
        }),
    ],
    exports: [],
    declarations: [
        ProductsListComponent,
        FundListComponent,
        BondIssuerListComponent,
        CertificateListComponent,
        BondListComponent,
        EditFundComponent, TabsEditFundComponent, DocumentFilesForFundComponent, UploadDocumentFundPopupComponent,
        GoldListComponent,
        EditGoldComponent,
        FeeTransferComponent,
        SetUpNewFeeFundComponent,
        NewBuyFeeFundComponent, NewSellFeeFundComponent, NewTransferFeeFundComponent,
        UpdateNavPopupComponent,
        EditFeeComponent,
        CheckChangeProductPopupComponent,
        EditDividendComponent,
        DividendListComponent,
        SipListComponent,
        EditSipComponent,
        NAVListComponent
    ],
    providers: [
        ThemeConstantService,
        LocaleService
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class ProductModule { }
